/*
if (!comments && (!_.isArray(ProposalFiles) || ProposalFiles.length === 0 || !ProposalFiles.find(ProposalFile => !ProposalFile.isArchived))) {
  return Promise.reject(new Error('Comments or Documents must be added.'));
}
*/
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isEmpty } from 'lodash';

export function proposalCommentFilesValidator(
  ProposalFormGroup: AbstractControl
): ValidationErrors | null {
  const {
    value: { comments, ProposalFiles }
  } = ProposalFormGroup;
  let { errors } = ProposalFormGroup;

  if (
    !comments &&
    (!Array.isArray(ProposalFiles) || ProposalFiles.length === 0)
  ) {
    errors = Object.assign(errors || {}, { commentFiles: true });
  } else if (errors) {
    delete errors['commentFiles'];
  }

  if (isEmpty(errors)) {
    errors = null;
  }

  ProposalFormGroup.setErrors(errors);
  return errors;
}
